import { useEffect, useState } from "react";

/** true bis 760 px — derselbe Breakpoint wie Shell und planung.css. */
const ABFRAGE = "(max-width: 760px)";

export function useIstTelefon(): boolean {
  const [telefon, setTelefon] = useState(() => typeof window !== "undefined" && window.matchMedia(ABFRAGE).matches);
  useEffect(() => {
    const mq = window.matchMedia(ABFRAGE);
    const wechsel = () => setTelefon(mq.matches);
    mq.addEventListener("change", wechsel);
    wechsel();
    return () => mq.removeEventListener("change", wechsel);
  }, []);
  return telefon;
}
